import { ISSUE_STATUS_MAPPING } from '@/core/modules/issues/constants'

export const getVisualTodayDate = (): string =>
    new Date().toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    })

export const getSnakeCaseTodayDate = () => {
    const currentDate = new Date()

    const day = currentDate.getDate().toString().padStart(2, '0')
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
    const year = currentDate.getFullYear().toString()

    return `${day}_${month}_${year}`
}

export const sanitizePdfText = (input?: string): string => {
    if (!input) return ''

    const unicodeSpacesRegex = /[\u00A0\u2000-\u200B\u202F\u205F\u3000]/g
    const controlCharsRegex =
        /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g
    const htmlTagsRegex = /<[^>]*>/g
    const multiWhitespaceRegex = /\s+/g
    const problematicUnicodeRegex = /[\uFFF0-\uFFFF\uD800-\uDFFF\u2028\u2029]/g
    const smartQuotesRegex = /[\u2018\u2019\u201A\u201B\u2032\u2035]/g
    const doubleSmartQuotesRegex = /[\u201C\u201D\u201E\u201F\u2033\u2036]/g
    const dashesRegex = /[\u2013\u2014\u2015]/g

    return input
        .replace(problematicUnicodeRegex, '')
        .replace(smartQuotesRegex, "'")
        .replace(doubleSmartQuotesRegex, '"')
        .replace(dashesRegex, '-')
        .replace(unicodeSpacesRegex, ' ')
        .replace(controlCharsRegex, ' ')
        .replace(htmlTagsRegex, '')
        .replace(multiWhitespaceRegex, ' ')
        .trim()
}

export const buildPdfSubtitle = (
    isFiltered: boolean,
    filteredTypes: string[],
    statuses: string[]
): string => {
    const parts: string[] = []

    if (isFiltered && filteredTypes?.length > 0) {
        parts.push(`Filtered - Type: ${filteredTypes.join(', ')}`)
    }

    if (isFiltered && statuses.length > 0) {
        let statusesText = statuses.map(
            (status) => ISSUE_STATUS_MAPPING[status as TIssueStatus]
        )
        const statusText =
            statuses.length === 1
                ? `Status: ${statusesText[0]}`
                : `Statuses: ${statusesText.join(', ')}`
        parts.push(statusText)
    }

    return parts.join(' | ')
}

export const createChunks = <T>(array: T[], size: number): T[][] => {
    const chunkSize = size > 0 ? size : array.length || 1
    return Array.from(
        { length: Math.ceil(array.length / chunkSize) },
        (_, index) => array.slice(index * chunkSize, (index + 1) * chunkSize)
    )
}
